module.exports = __webpack_public_path__ + "media/images/illustrations/saving_coins_small-659b1fe0f77b99fda47efbe2542aacc3.svg";